import { sum } from 'd3-array'
import { CounterDataTemporalDailyPark } from '../../client'
import ColorScale from '../../utils/colorScale'
import { defaultAxis, layoutTemplate } from '../../utils/plotly'
import { sortByDateKey } from '../../utils/sort'
import Plot from '../shared/Plot'
import { categories, DEFAULT_PLOT_CONFIG, PLOT_STYLE, PLOT_TEMPORAL_DAILY_PARKS } from './constants'
import useData from './useData'

const PLOT_LAYOUT = {
  template: layoutTemplate,
  paper_bgcolor: ColorScale.branco,
  plot_bgcolor: ColorScale.branco_clear,
  showlegend: false,
  hovermode: 'x unified',
  autosize: true,
  barmode: 'stack',
  margin: { b: 40, t: 10, r: 10, l: 40 },
  xaxis: {
    ...defaultAxis,
    fixedrange: true,
    mirror: 'ticks',
    linewidth: 2,
    gridwidth: 2,
    title: 'Dia',
  },
  yaxis: { ...defaultAxis, fixedrange: true, ticksuffix: '%', range: [0, 110] },
}

const PlotDailyWindFarmTotal = ({
  isLoading,
  dateIn,
  dateFin,
  windFarmId,
  revision,
  categorySelection,
}: {
  isLoading: boolean
  dateIn: Date
  dateFin: Date
  windFarmId: number
  revision: number
  categorySelection: categories
}) => {
  const { isLoading: dataIsLoading, dailyParks: allDailyParks } = useData(dateIn, dateFin)

  const dailyParks = sortByDateKey<CounterDataTemporalDailyPark>(
    allDailyParks.filter(e => e.wf_id === windFarmId),
    'ts',
    'asc'
  )

  if (isLoading || dataIsLoading || dailyParks.length === 0) {
    return (
      <div style={PLOT_STYLE} className='pf-v5-u-mt-0'>
        <Plot
          divId={PLOT_TEMPORAL_DAILY_PARKS}
          useResizeHandler
          key={revision}
          data={[]}
          layout={PLOT_LAYOUT}
          config={DEFAULT_PLOT_CONFIG}
          style={PLOT_STYLE}
        />
      </div>
    )
  }

  const dtNow = new Date()

  const days = dailyParks
    .map(dd => dd.ts)
    .sort((a, b) => new Date(a).getTime() - new Date(b).getTime())

  const y = days.map(day => {
    const dd = dailyParks.find(m => new Date(m.ts).getTime() === new Date(day).getTime())

    if (!dd || new Date(dd.ts) > dtNow) return undefined

    const downtime = sum(categorySelection.downtime.map(cat => dd[cat]))
    const online = sum(categorySelection.online.map(cat => dd[cat]))

    return (online / (online + downtime)) * 100
  })

  const data = [
    {
      ...defaultAxis,
      y,
      x: days,
      name: 'Disponibilidade Temporal',
      type: 'bar',
      marker: { color: ColorScale.verde },
    },
  ]

  return (
    <div style={PLOT_STYLE} className='pf-v5-u-mt-0'>
      <Plot
        divId={PLOT_TEMPORAL_DAILY_PARKS}
        useResizeHandler
        key={revision}
        data={data}
        layout={PLOT_LAYOUT}
        config={DEFAULT_PLOT_CONFIG}
        style={PLOT_STYLE}
      />
    </div>
  )
}

export default PlotDailyWindFarmTotal
